import React, { Suspense } from 'react';
import { Redirect, Switch, Route } from 'react-router-dom';

import { PageLoad } from '../Components/LoadingScreen/PageLoad';

import { Orders } from '../Pages/Orders';
import { HoursOfOperations } from '../Pages/HoursOfOperations';
import { ContactUs } from '../Pages/ContactUs';
import { ChangePassword } from '../Pages/ChangePassword';
import { MyProfile } from '../Pages/MyProfile';

const BasePage = () => {
  return (
    <Suspense fallback={<PageLoad />}>
      <Switch>
        <Redirect exact from='/' to='/orders' />
        <Redirect from='/login' to='/orders' />
        <Redirect exact from='/login-password' to='/orders' />

        <Route path='/orders' component={Orders} />
        <Route path='/hours-of-operations' component={HoursOfOperations} />
        <Route path='/contact-us' component={ContactUs} />
        <Route path='/change-password' component={ChangePassword} />
        <Route path='/my-profile' component={MyProfile} />

        <Redirect to='/404' />
      </Switch>
    </Suspense>
  );
}

export { BasePage };
